import Vue from 'vue';
import PercentInput from 'vue-percent-input';

Vue.use(PercentInput);
